// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9RRkg","text":"styles_text__ql9aU","btn":"styles_btn__Lq6jP"};